// Footer-Zeile unterhalb der Box - ausserhalb, direkt dahinter, geteilt mit
// z.B. einem Modal-Link, damit sich beide nicht gegenseitig ueberschreiben.
export const footerContainer = ( textarea ) => {
    const wrapper = textarea.closest( '.textarea-with-toggles' );
    if ( !wrapper ) {
        return null;
    }

    const next = wrapper.nextElementSibling;
    if ( next && next.classList.contains( 'textarea-with-toggles__footer' ) ) {
        return next;
    }

    const footer = document.createElement( 'div' );
    footer.classList.add( 'textarea-with-toggles__footer' );
    wrapper.after( footer );
    return footer;
};

// maxlength verhindert Tippen ueber das Limit hinaus zuverlaessig, beim
// Einfuegen (Paste, htmx-Swap, ...) ist das je nach Browser/Quelle nicht
// garantiert - deshalb hier zusaetzlich hart kappen.
export const enforceMaxLength = ( textarea, max ) => {
    if ( textarea.value.length > max ) {
        textarea.value = textarea.value.slice( 0, max );
    }
};

export const updateCounter = ( textarea, counter, max ) => {
    enforceMaxLength( textarea, max );
    counter.textContent = `${ textarea.value.length }/${ max } Zeichen`;
    counter.classList.toggle( 'char-counter--limit', textarea.value.length >= max );
};

export const initTextarea = ( textarea ) => {
    const max = textarea.maxLength;

    // Ohne maxlength gibt es kein "maximal X Zeichen" anzuzeigen. Der Browser
    // liefert dafuer -1, jsdom 0 - und ein Limit von 0 waere ohnehin sinnlos.
    if ( max <= 0 ) {
        return;
    }

    textarea.setAttribute( 'data-char-counter-added', 'true' );

    const footer = footerContainer( textarea );
    if ( !footer ) {
        return;
    }

    const counter = document.createElement( 'span' );
    counter.classList.add( 'char-counter' );
    footer.appendChild( counter );

    updateCounter( textarea, counter, max );
    textarea.addEventListener( 'input', () => updateCounter( textarea, counter, max ) );
};

export const init = ( selector = 'textarea[data-char-counter]:not([data-char-counter-added="true"])' ) => {
    document.querySelectorAll( selector ).forEach( initTextarea );
};
